import { CHECKOUT_STEP } from '@client/analytics/redux';
import { createAction } from '@reduxjs/toolkit';

export const analyzeCheckoutStepView = createAction<CHECKOUT_STEP>('analyzeCheckoutStepView');
export const analyzeOrderConfirmationPage = createAction<boolean>('analyzeOrderConfirmationPage');
